import ajax from "./helpers/ajax";
import Modal from "./Modal";
import { isAuthError, getErrorMessage } from "./helpers/errors";
import Global from "./Global";

class User {
  constructor() {
    this.user = window.digiteketData?.user || false;
    this.onLogin = null;

    document.addEventListener("DOMContentLoaded", () => {
      document
        .querySelector("body")
        .addEventListener("submit", (e) =>
          this.onLoginFormSubmit.call(this, e)
        );
    });
  }

  onLoginFormSubmit(e) {
    if (
      !(
        e.target.tagName.toLowerCase() === "form" &&
        "ajax" in e.target.dataset &&
        e.target.getAttribute("name") === "login"
      )
    ) {
      return;
    }

    e.preventDefault();

    const form = e.target;

    form.classList.add("form--is-loading");

    const data = Array.from(new FormData(form).entries()).reduce(
      (data, [key, value]) => {
        return {
          ...data,
          [key]: value,
        };
      },
      {}
    );

    ajax
      .post("digiteket_login", data)
      .then((response) => {
        if (!response.success) {
          throw new Error(response?.data);
        }
      })
      .then(async (response) => {
        // Remove any error messages from previous attempts
        const formRow = form.querySelector(".form__row--is-error");
        const formMessage = formRow
          ? formRow.querySelector(".form__message")
          : null;

        if (formRow) {
          formRow.classList.add("form__row--is-hidden");

          if (formMessage) {
            formMessage.innerHTML = "";
          }
        }

        if (
          data.hasOwnProperty("redirect_to") &&
          typeof data.redirect_to === "string" &&
          data.redirect_to !== window.location.href
        ) {
          // Found redirect_to in form data that differs from current URL, redirect to that URL
          window.location.href = data.redirect_to;
        } else {
          if (!this.isLoggedIn()) {
            // Reload the page if user was not previously logged in
            window.location.reload();
          } else {
            // User was already logged in, set current user
            this.setUser(response.data);

            // Refresh ajax nonce and logout URL
            await ajax.refreshNonce();

            // Close modal
            Modal.close();

            // Trigger login callback (if defined)
            if (typeof this.onLogin === "function") {
              this.onLogin(null, response.data);
            }

            // Clear login callback
            this.onLogin = null;
          }
        }
      })
      .catch((error) => {
        const message = isAuthError(error)
          ? "Vi hittade ingen användare med angivna uppgifter."
          : "Ett oväntat fel inträffade, försök igen.";

        // Select elements
        const formRow = form.querySelector(".form__row--is-error");
        const formMessage = formRow
          ? formRow.querySelector(".form__message")
          : null;

        if (formRow && formMessage) {
          // Display error message row
          formRow.classList.remove("form__row--is-hidden");

          // Set error message text
          formMessage.innerHTML = getErrorMessage(message);

          // focus error message
          Global.focusFormMessage();
        }

        if (typeof this.onLogin === "function") {
          this.onLogin(error, null);
        }
      })
      .finally(() => {
        form.classList.remove("form--is-loading");
      });
  }

  login(callback) {
    // Open login modal
    Modal.open("modal-login");

    if (typeof callback === "function") {
      // Set onLogin callback
      this.onLogin = callback;
    }
  }

  setUser(user) {
    this.user = user;
  }

  getUser() {
    return this.user;
  }

  isLoggedIn() {
    return this.user !== false;
  }

  hasRole(role) {
    const roles = this.user?.roles || [];

    return roles.includes(role);
  }

  isAdmin() {
    return this.hasRole("administrator");
  }

  can(capability) {
    const roles = this.user?.roles || [];
    const capabilities = this.user?.capabilities || [];

    return capabilities.includes(capability) || roles.includes(capability);
  }
}

const user = new User();

export default user;
